import React from 'react';
import { motion } from 'framer-motion';
import { Mail, Eye, EyeOff } from 'lucide-react';

const FormInput = ({
  label,
  name,
  type = 'text',
  placeholder,
  icon,
  rightIcon,
  error,
  required = false,
  register,
  className = '',
  ...props
}) => {
  const [showPassword, setShowPassword] = React.useState(false);
  const isPassword = type === 'password';
  const inputType = isPassword && showPassword ? 'text' : type;

  return (
    <div className="mb-4">
      <label className="block text-sm font-medium text-foreground mb-1">
        {label} {required && <span className="text-destructive">*</span>}
      </label>
      
      <div className="relative">
        {icon && (
          <div className="absolute left-3 top-1/2 -translate-y-1/2 text-muted-foreground">
            {icon}
          </div>
        )}
        
        <input
          {...register(name)}
          type={inputType}
          placeholder={placeholder}
          className={`
            w-full h-12 px-4 ${icon ? 'pl-11' : ''} ${rightIcon || isPassword ? 'pr-11' : ''}
            border rounded-lg
            ${error ? 'border-destructive focus:ring-destructive' : 'border-border focus:ring-primary'}
            focus:outline-none focus:ring-2
            transition-all duration-200
            bg-background
            ${className}
          `}
          {...props}
        />
        
        {isPassword && (
          <button
            type="button"
            onClick={() => setShowPassword(!showPassword)}
            className="absolute right-3 top-1/2 -translate-y-1/2 text-muted-foreground hover:text-foreground transition-colors"
          >
            {showPassword ? <EyeOff className="w-5 h-5" /> : <Eye className="w-5 h-5" />}
          </button>
        )}
        
        {rightIcon && !isPassword && (
          <div className="absolute right-3 top-1/2 -translate-y-1/2">
            {rightIcon}
          </div>
        )}
      </div>
      
      {error && (
        <motion.p
          initial={{ opacity: 0, y: -5 }}
          animate={{ opacity: 1, y: 0 }}
          className="text-destructive text-sm mt-1"
        >
          {error}
        </motion.p>
      )}
    </div>
  );
};

export default FormInput;